import { Variants } from "framer-motion";

export const slide: Variants = {
  exit: { y: -20, opacity: 0 },
  enter: { y: 0, opacity: 1 },
};
